import React from 'react'

//Styles
import styles from './Divider.module.scss'

interface Props {
  variant: "light" | "dark",
  children: React.ReactNode | React.ReactNode[]
}

const Divider = ({ variant = "light", children }:Props) => {
  const [first, ...rest] = children instanceof Array ? children : [children]
  return (
    <span className={styles.dividerGroup}>
      { first }
      { 
        rest.filter(child => child).map((child, index) => (
          <React.Fragment key={index}>
            <span className={`${styles.divider} ${variant}`}>&nbsp;</span>
            {child}
          </React.Fragment>
        ))
      }
    </span>
  )
}

export default Divider